import { apiClient } from './client';

export interface Profile {
  id: string;
  name: string;
  avatarEmoji: string;
  isDefault: boolean;
  handle: string;
  settings: Record<string, any>;
  createdAt: number;
  updatedAt: number;
}

export interface CreateProfilePayload {
  name: string;
  avatarEmoji?: string;
  handle?: string;
  settings?: Record<string, any>;
}

export interface UpdateProfilePayload {
  name?: string;
  avatarEmoji?: string;
  handle?: string;
  settings?: Record<string, any>;
}

export const profilesApi = {
  list: async (): Promise<Profile[]> => {
    const { data } = await apiClient.get('/api/profiles');
    return data;
  },

  get: async (id: string): Promise<Profile> => {
    const { data } = await apiClient.get(`/api/profiles/${id}`);
    return data;
  },

  create: async (payload: CreateProfilePayload): Promise<Profile> => {
    const { data } = await apiClient.post('/api/profiles', payload);
    return data;
  },

  update: async (id: string, payload: UpdateProfilePayload): Promise<Profile> => {
    const { data } = await apiClient.put(`/api/profiles/${id}`, payload);
    return data;
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/api/profiles/${id}`);
  },

  setDefault: async (id: string): Promise<void> => {
    await apiClient.post(`/api/profiles/${id}/set-default`);
  },
};
